import { Outlet } from "react-router";
import { useUsersSocket } from "../../hooks/socket/use-users-scoket";

export default function ITLayout() {
    useUsersSocket()
    return <Outlet />;
}